/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".exception_table.table-design[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td.ellipsis_td[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{text-align:center;position:relative;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;width:275px;display:inline-block}\n/*# sourceMappingURL=exception-report.component.css.map*/"];
export { styles as styles };
